module.exports = __webpack_public_path__ + "img/twitter.bd74f485.svg";